import { SyntheticEvent } from 'react';

export const preventedDefault = <E extends SyntheticEvent>(
  callback: (event: E) => void,
) => (event: E) => {
  if (event?.preventDefault && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }

  callback(event);
};
